var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.414,
    height: 11.688,
    viewBox: "0 0 45.414 11.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right",
    d: "M5.227-4.164H3.359V0H1.016V-11.375H5.242a4.778,4.778,0,0,1,3.109.9A3.1,3.1,0,0,1,9.445-7.937,3.5,3.5,0,0,1,8.941-6,3.437,3.437,0,0,1,7.414-4.758L9.875-.109V0H7.359Zm-1.867-1.9H5.25a1.936,1.936,0,0,0,1.367-.449A1.606,1.606,0,0,0,7.1-7.75a1.719,1.719,0,0,0-.457-1.266,1.9,1.9,0,0,0-1.4-.461H3.359ZM13.719,0H11.375V-11.375h2.344ZM24.891-1.437A4.068,4.068,0,0,1,23.1-.262a7.492,7.492,0,0,1-2.562.418,5.076,5.076,0,0,1-2.59-.645A4.3,4.3,0,0,1,16.23-2.359a6.585,6.585,0,0,1-.621-2.883v-.773a6.994,6.994,0,0,1,.574-2.949,4.248,4.248,0,0,1,1.656-1.906,4.771,4.771,0,0,1,2.535-.66,4.751,4.751,0,0,1,3.164.965,4.123,4.123,0,0,1,1.352,2.809H22.609a2.268,2.268,0,0,0-.691-1.43,2.208,2.208,0,0,0-1.473-.453,2.078,2.078,0,0,0-1.82.9,4.724,4.724,0,0,0-.633,2.672v.727a4.5,4.5,0,0,0,.68,2.7,2.327,2.327,0,0,0,1.992.914,2.6,2.6,0,0,0,1.883-.562V-4.25H20.414V-5.977h4.477ZM36.047,0H33.7V-4.875h-4.57V0H26.789V-11.375h2.344v4.609H33.7v-4.609h2.344ZM46.43-9.477H42.945V0H40.6V-9.477H37.164v-1.9H46.43Z",
    transform: "translate(-1.016 11.531)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.5cb0287341bcbeb26eb3766528dce7b5.svg";
export { ForwardRef as ReactComponent };